import { defineMessages } from 'react-intl';
import { META_TITLE_PREFIX } from '../constants';

const messages = defineMessages({
  metaTitle: {
    id: 'browse.meta.title-2',
    defaultMessage: 'Browse Classical Genres, Periods, Instruments',
  },
  metaDescription: {
    id: 'browse.meta.description',
    defaultMessage: 'Browse by composer, performer, instrument, genre or epoch and more!',
  },
  metaKeywords: {
    id: 'browse.meta.keywords',
    defaultMessage:
      'browse classical music, browse classical performers, classical instrumental music, mozart classical music, beethoven classical music',
  },
});

export function getBaseHelmet(intl) {
  return {
    title: META_TITLE_PREFIX + intl.formatMessage(messages.metaTitle),
    description: intl.formatMessage(messages.metaDescription),
    keywords: intl.formatMessage(messages.metaKeywords),
  };
}
